import _ from 'lodash'

export const centsToDollars = (cents: number) => _.round(cents / 100, 2)
